import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import MaterialOpaqueDetail from '../../components/material_opaque/MaterialOpaqueDetail';
import { createMaterialOpaque } from '../../redux/material_opaque/material_actions';
import { defaultRejectHandler } from '../../utils/utility';

class MaterialOpaqueCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.materialDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newMaterial = this.materialDetail.getWrappedInstance().getMaterialData();
    this.props.createMaterial(newMaterial);
  }

  render() {
    const { isCreating, errorMessage, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create opaque material')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MaterialOpaqueDetail
            ref={ref => (this.materialDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="material-opaque-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.material.opaque.errorMessage,
  isCreating: state.material.opaque.isCreating,
});

const mapDispatchToProps = dispatch => ({
  createMaterial: material =>
    defaultRejectHandler(
      dispatch(
        createMaterialOpaque(
          material.name,
          material.density,
          material.specific_heat,
          material.thermal_conductivity,
          material.description || '',
          material.image,
        )
      )
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(MaterialOpaqueCreateModal)
);



// WEBPACK FOOTER //
// ./src/modal/material_opaque/MaterialOpaqueCreateModal.js